import React from 'react';
import { useDispatch } from 'react-redux';

import {
  setShow as setModalShow,
  setOrderId,
  setNpsUrl,
} from '~features/modals/ducks';

import StandardNotification from './StandardNotification';

const FeedbackNotification = ({ notification, ...rest }) => {
  const dispatch = useDispatch();
  const { orderId, npsUrl } = notification.details;

  const handleClick = () => {
    dispatch(setOrderId(orderId));
    dispatch(setNpsUrl(npsUrl));
    dispatch(setModalShow(npsUrl ? 'EXTERNAL_FEEDBACK' : 'ORDER_FEEDBACK'));
  };

  return (
    <StandardNotification
      {...rest}
      notification={notification}
      description={`Anna palautetta tilauksesta ${orderId}`}
      onClick={handleClick}
      hideInitiator
    />
  );
};

export default FeedbackNotification;
